<template>
  <ul class="scroll-list">
    <slot />
  </ul>
</template>

<style scoped lang="scss">
.scroll-list {
  @include flex-container(row, flex-start);
  gap: 16px;

  @extend %horizontal-scroll;
  overflow: auto;

  padding-bottom: 8px;
}
</style>
